import wixWindow from 'wix-window';

const isMobile = wixWindow.formFactor === "Mobile"

$w.onReady(function () {
	if (isMobile) {
        $w("#backToShop").collapse();
    }
});